namespace Matrix.Workflow {
    export class RunBookColumns {
        static columnsKey = 'Workflow.RunBook';
    }
}
